import { html } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { TilesVariantSelectorBase } from "./tiles-variant-selector-base.js";
import { IVariant } from './variant-selector-base.js';

export class TilesVariantSelectorV1 extends TilesVariantSelectorBase {
    protected template = () => html`
        <div class="c-variant-selector__term-definition">
            <label class="c-variant-selector__label js-select-variant-label control-label">${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}</label>
        </div>
        <div class="c-variant-selector__term-description c-variant-selector__term-description_tiles">
        ${repeat(this.variantSelectorData.variants, (variant: IVariant) => html`
            <button type="button" class="c-variant-selector__variant-tile js-variant" data-variantid="${variant.id}">
                <span class="c-variant-selector__variant-tile-value">${variant.name}</span>
                <div class="c-variant-selector__variant-tile-unavailable-text js-unavailable-text-container" style="display:none;">
                    <span class="c-variant-selector__variant-tile-unavailable-text-label js-unavailable-text"></span>
                </div>
            </button>
        `)}
        </div>
    `;

    protected getDataBeforeRender() {
        return {
            variantTypeName: this.variantType.name.toLowerCase(),
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
            labels: { select: this.translations.get('selectVariantPrefix'), changeSelection: this.translations.get('changeSelectionVariantPrefix') }
        };
    }
}
